import { filterOutCampaignAndAdgroupName } from '../utils';

function updateEntitySchemaForAgeGender({
  entitySchema,
  i18n,
  scope,
}) {
  let entitySchemaCopy = entitySchema;

  entitySchemaCopy.properties.AgeGroup = {
    property: 'AgeGroup',
    name: i18n.getString('ColumnName_AgeGroup'),
    title: i18n.getString('ColumnName_AgeGroup'),
    enumType: 'AgeGroup',
    enum: [0, 1, 2, 3, 4, 5, 6, 7],
    type: 'string',
    enumValueMap: {
      0: i18n.getString('Dimension_AgeGroup_0'),
      1: i18n.getString('Dimension_AgeGroup_1'),
      2: i18n.getString('Dimension_AgeGroup_2'),
      3: i18n.getString('Dimension_AgeGroup_3'),
      4: i18n.getString('Dimension_AgeGroup_4'),
      5: i18n.getString('Dimension_AgeGroup_5'),
      6: i18n.getString('Dimension_AgeGroup_6'),
      7: i18n.getString('Dimension_AgeGroup_7'),
    },
    chooseType: 'checkbox',
    filterable: true,
  };

  entitySchemaCopy.properties.Gender = {
    property: 'Gender',
    name: i18n.getString('ColumnName_Gender'),
    title: i18n.getString('ColumnName_Gender'),
    enumType: 'Gender',
    enum: [0, 1, 2],
    type: 'string',
    enumValueMap: {
      0: i18n.getString('Dimension_Gender_0'),
      1: i18n.getString('Dimension_Gender_1'),
      2: i18n.getString('Dimension_Gender_2'),
    },
    chooseType: 'checkbox',
    filterable: true,
  };

  entitySchemaCopy.properties.Medium = {
    property: 'Medium',
    name: i18n.getString('ColumnName_Medium'),
    title: i18n.getString('ColumnName_Medium'),
    enumType: 'Medium',
    enum: [0, 1, 2, 10, 11],
    type: 'string',
    enumValueMap: {
      0: i18n.getString('Dimension_Medium_0'),
      1: i18n.getString('Dimension_Medium_1'),
      2: i18n.getString('Dimension_Medium_2'),
      10: i18n.getString('Dimension_Medium_3'),
      11: i18n.getString('Dimension_Medium_4'),
    },
    chooseType: 'checkbox',
    filterable: true,
  };

  entitySchemaCopy = filterOutCampaignAndAdgroupName(scope, entitySchemaCopy);

  return entitySchemaCopy;
}

export class DimensionsAgeAndGenderSchemaProcessor {
  constructor(options) {
    this.i18n = options.i18n;
    this.scope = options.scope;
  }

  updateEntitySchemaForFeatures(entitySchema) {
    updateEntitySchemaForAgeGender({
      entitySchema,
      i18n: this.i18n,
      scope: this.scope,
    });
    return entitySchema;
  }
}
